import nl from '~public/images/about-warm-home-20261018.jpg';
import nlWebp from '~public/images/about-warm-home-20261018.jpg?format=webp';
import be from '~public/images/about-be-20261018.jpg';
import beWebp from '~public/images/about-be-20261018.jpg?format=webp';
import fr from '~public/images/about-fr-20261018.jpg';
import frWebp from '~public/images/about-fr-20261018.jpg?format=webp';
import es from '~public/images/about-es-20261018.jpg';
import esWebp from '~public/images/about-es-20261018.jpg?format=webp';
import global from '~public/images/about-global-20261018.jpg';
import globalWebp from '~public/images/about-global-20261018.jpg?format=webp';
const images = {nl: {picture: nl, pictureWebp: nlWebp},be: {picture: be, pictureWebp: beWebp},fr: {picture: fr, pictureWebp: frWebp},es: {picture: es, pictureWebp: esWebp},global: {picture: global, pictureWebp: globalWebp}};
export const marketAboutImages = locale => {
  const normalized = String(locale || 'en').toLowerCase().replace('_', '-');
  const key = normalized === 'nl-be' ? 'be' : normalized.split('-')[0];
  return images[key] || images.global;
};
